import { createSelector } from 'reselect';
import { fetchInstallerTestExpectedActionTypes } from './../actions/types';
import { cachedRequestByIdReducer } from './helpers';
import { utils } from '../helpers';

export const installerTestExpectedReducer = (successAction, requestAction) =>
  (state = {}, action) => {
    switch (action.type) {
      case successAction:
        const newState = { ...state };
        Object.keys(action.response).forEach(k => {
          if (action.response[k].Runners)
            newState[k] = action.response[k];
          else {
            newState[k].Expected = action.response[k] ? action.response[k].Expected : 0;
            newState[k].Username = action.response[k] ? action.response[k].Username : '';
          }
        });

        return newState;
      case requestAction:
        return {};
      default:
        return state;
    }
  };

const installerTestExpected = cachedRequestByIdReducer(
  fetchInstallerTestExpectedActionTypes,
  'Entries', ['request'],
  () => installerTestExpectedReducer(
    fetchInstallerTestExpectedActionTypes.success,
    fetchInstallerTestExpectedActionTypes.request
  )
);

export default installerTestExpected;

export const getinstallerTestExpectedState = state => state.installerTestExpected;

export const getinstallerTestExpected = state =>
  getinstallerTestExpectedState(state).Entries;

export const installerTestExpectedByRunner = createSelector(
  getinstallerTestExpected,
  (installerTestExpected) => {
    const result = utils.propertyArrayAccumulatorReducer(
      Object.values(installerTestExpected),
      'Runners'
    );
    return result;
  });





// WEBPACK FOOTER //
// src/reducers/installerTestExpected.js